import { makeStyles } from "@material-ui/core";
import React from "react";

export function BackIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

const useStyles = makeStyles(() => ({
  backBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    background: "#4F46E5",
    border: "1px solid #4F46E5",
    color: "#fff",
    borderRadius: 6,
    padding: 0,
    cursor: "pointer",
    flexShrink: 0,
    transition: "background 0.15s, border-color 0.15s",
    "&:hover": { background: "#4338CA", borderColor: "#4338CA" },
  },
}));

export default function BackButton({ onClick, ariaLabel = "Back", className }) {
  const classes = useStyles();
  return (
    <button
      type="button"
      className={className ? `${classes.backBtn} ${className}` : classes.backBtn}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <BackIcon />
    </button>
  );
}
